import { InvitationStatus } from "./InvitationStatus";

export class MultiplayerSessionInvitation {
    multiplayerSessionId!: string;
    inviterUserId?: string;
    inviteeUserId!: string;
    invitationStatus!: InvitationStatus;
}